import React from "react";
import "./WhoWeAre.css";
import { FaGlobe, FaCog, FaMedal, FaLock, FaUsers, FaPuzzlePiece, FaFileAlt, FaChartBar } from "react-icons/fa";
import whoImage from "./Images/WhoWeAre.png";
const items = [
    { icon: <FaGlobe />, title: "TOTAL IT SOLUTIONS", color: "#0096D6" },
    { icon: <FaCog />, title: "RELIABILITY & EFFICIENCY", color: "#32C866" },
    { icon: <FaMedal />, title: "QUALITY SERVICES", color: "#ED8A33" },
    { icon: <FaLock />, title: "DATA SECURITY", color: "#0096D6" },
    { icon: <FaUsers />, title: "DEDICATED QUALITY ASSURANCE TEAM", color: "#32C866" },
    { icon: <FaPuzzlePiece />, title: "EXTENSIVE IN-HOUSE TRAINING PROGRAMS", color: "#ED8A33" },
    { icon: <FaFileAlt />, title: "PROVEN TRACK RECORD", color: "#0096D6" },
    { icon: <FaChartBar />, title: "EXCEPTIONAL PERSONNEL RETENTION RATE", color: "#32C866" },
];

const WhoWeAre = () => {
    return (


        <>
            <section className="who-section">
                <div className="who-wrapper">
                    <div className="who-image">
                        <img src={whoImage} alt="Who We Are" />
                    </div>
                    <div className="who-content">
                        <h2 className="who-heading">WHO WE ARE</h2>
                        <p>
                            A.P Tech Solution is a leading software development company delivering innovative digital solutions to startups, small businesses, and enterprises alike. With years of technical expertise and a passion for problem-solving, we help organizations streamline processes and scale with confidence.
                        </p>
                        <p>
                            From custom software and mobile apps to enterprise web platforms, our solutions are crafted to match your exact business needs. Whether you're launching a product or modernizing legacy systems — we’re the team to make it happen.
                        </p>
                        <p>
                            What sets us apart? Our commitment to quality, transparency, and long-term support. At A.P Tech Solution, we don’t just build software — we build partnerships that grow with your business.
                        </p>
                    </div>
                </div>
            </section>



        <div className="different-wrapper">
            <h2>HOW WE ARE DIFFERENT</h2>
            <p>We help brands make an impact.</p>
            <div className="different-container">
                <div className="different-grid">
                    {items.map((item, index) => (
                        <div className="different-card" key={index}>
                            <div className="icon-circle" style={{ "--icon-color": item.color }}>
                                <div className="icon">{item.icon}</div>
                            </div>
                            <h4>{item.title}</h4>
                            
                        </div>
                    ))}
                </div>
            </div>
        </div>
        </>
    );
};

export default WhoWeAre;
